/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MemberProfileScanLimitPostModel } from '../../models/member-profile-scan-limit-post-model';
import { MemberProfileScanLimitResponse } from '../../models/member-profile-scan-limit-response';

export interface AdminMemberProfileScanLimitPost$Params {
  
    /**
     * Person id and desired override (positive sets override; zero or negative clears).
     */
    body?: MemberProfileScanLimitPostModel
}

export function adminMemberProfileScanLimitPost(http: HttpClient, rootUrl: string, params?: AdminMemberProfileScanLimitPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<MemberProfileScanLimitResponse>> {
  const rb = new RequestBuilder(rootUrl, adminMemberProfileScanLimitPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<MemberProfileScanLimitResponse>;
    })
  );
}

adminMemberProfileScanLimitPost.PATH = '/Admin/MemberProfileScanLimit';
